import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	preheading: {
		id: 'discountSignup.purchaseForm.preheading',
		defaultMessage: 'No commitment. Cancel anytime.',
		description: 'Signup flow payment subtitle',
	},
	trialDayHeading: {
		id: 'signup.upsell.extendedTrialSubHeading',
		defaultMessage: 'Start your free {amount}-{quantity, plural, one {day} other {day}} {br}trial',
		description: 'Signup for a free trial for a number amount of days',
	},
	trialMonthHeading: {
		id: 'singup.upsell.extendedTrialMonthHeading',
		defaultMessage: 'Start your free {amount}-{quantity, plural, one {month} other {month}} trial',
		description: 'Signup for a free trial for a number amount of months',
	},
	getCalm: {
		id: 'profile.manageSubscription.upsellButton',
		defaultMessage: 'Get Calm Premium',
		description: 'A button the user can click to purchase a Calm subscription again',
	},
});
